import React, { Component } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import PropTypes from "prop-types";

import { media } from "utils/style";

class Alert extends Component {
  state = {
    showBanner: true
  };

  handleClose = () => {
    this.setState(
      { showBanner: false },
      this.props.afterCloseRequest ? () => this.props.afterCloseRequest() : null
    );
  };
  render() {
    const { children, alertType, hideCloseIcon, afterCloseRequest, noMargin, ...props } = this.props;

    return ReactDOM.createPortal(
      <StyledAlert
        alertType={alertType}
        showBanner={this.state.showBanner}
        hideCloseIcon={hideCloseIcon}
        noMargin={noMargin}
        {...props}
      >
        <div>
          <p>{children}</p>
          <button aria-label="close" onClick={this.handleClose}>
            <svg focusable="false" width="15" height="15" viewBox="0 0 36 36">
              <path
                aria-hidden="true"
                fillRule="nonzero"
                d="M35.463 2.213L33.787.537 18 16.322 2.213.537.537 2.213 16.322 18 .537 33.787l1.676 1.676L18 19.678l15.787 15.785 1.676-1.676L19.678 18z"
              />
            </svg>
          </button>
        </div>
      </StyledAlert>,
      document.getElementById("notification_banner")
    );
  }
}
Alert.propTypes = {
  alertType: PropTypes.oneOf(["error", "info", "success", "warning"]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  afterCloseRequest: PropTypes.func,
  hideCloseIcon: PropTypes.bool,
  noMargin: PropTypes.bool
};

export default Alert;

const StyledAlert = styled.div`
  padding: 15px 0;
  position: relative;
  /* margin-bottom: -45px; */
  display: ${({ showBanner }) => (showBanner ? "block" : "none")};

  ${({ alertType }) => {
    let backgroundColor = "";
    let color = "#000";
    let outline = "#000";

    if (alertType === "error") {
      backgroundColor = "#ed7000";
      color = "#fff";
    } else if (alertType === "warning") {
      backgroundColor = "#ffbc3d";
      outline = "#fff";
    } else if (alertType === "info") {
      backgroundColor = "rgb(227, 242, 253)"; // "#0088ce"
      color = "rgb(0, 0, 0)"; // "#fff";
    } else if (alertType === "copycliboard") {
      backgroundColor = "rgb(227, 242, 253)"; // "#E3F2FD"
      color = "rgb(0, 0, 0)"; //"#000";
    } else {
      backgroundColor = "rgb(220, 245, 230)"; //"#00ac3e";
      color = "rgb(0, 0, 0)"; //"#ffffff";
    }
    return `
      background-color: ${backgroundColor};

      svg {
        fill: ${color}
      }

      p, a {
        color: ${color};
        font-weight: bold;
        font-size: 14px;
      }

    `;
  }}

  ${({ noMargin }) => noMargin && `margin-bottom: 0;`}
  ${({ hideCloseIcon }) =>
    hideCloseIcon &&
    `
    button {
      display: none;
    }
  `}

  button {
    position: absolute;
    right: 16px;
    top: 0;
    border: 0;
    background: 0;
    padding: 0;
    cursor: pointer;
  }

  div {
    position: relative;
    max-width: 1272px;
    margin: 0 auto;
  }

  p {
    padding: 0 20px;
    max-width: 95%;
  }

  ${media.mobile`
    margin-bottom: -10px;
    padding: 12px 16px;

    p {
      padding: 0;
      max-width: 85%;
    }

    button {
      right: 8px;
    }
  `}
`;
